import gql from 'graphql-tag';

export const GET_AUTH_INFO = gql`
  query {
    configuracion {
      authInfo {
        nombreUsuario
        razonSocial
        nombre
        accessToken
        rol
        correo
        fotoPerfil
      }
    }
  }
`;
